import {
  inventoryItemIdFormat,
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
  transferSessionIdFormat,
} from "@redotech/redo-ids/ids";
import { ScanKind } from "@redotech/redo-model/inventory/scan-kind";
import * as z from "zod";

const baseInput = z.object({
  locationId: locationIdFormat.schema,
  sourceStorageLocationId: storageLocationIdFormat.schema,
  destinationStorageLocationId: storageLocationIdFormat.schema,
});

export const executeInstantTransfer = {
  name: "executeInstantTransfer" as const,
  // Not a discriminatedUnion: deployed clients predate the `type` field and
  // send product transfers without it, so the product variant keeps `type`
  // optional.
  input: z.union([
    baseInput.extend({
      type: z.literal(ScanKind.product).optional(),
      productId: productIdFormat.schema,
      quantity: z.number().int().positive().max(1_000_000),
    }),
    baseInput.extend({
      type: z.literal(ScanKind.inventoryItem),
      inventoryItemId: inventoryItemIdFormat.schema,
    }),
  ]),
  output: z.object({
    success: z.boolean(),
    transferSessionId: transferSessionIdFormat.schema.optional(),
    error: z.string().optional(),
  }),
};

export type ExecuteInstantTransferInput = z.infer<
  typeof executeInstantTransfer.input
>;

export type ExecuteInstantTransferOutput = z.infer<
  typeof executeInstantTransfer.output
>;
